import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import { seniorityDefinition, seniorityHandler } from './seniority';

export const multiSeniorityDefinition: FilterDefinition<
  MultiFilter<ListFilter>
> = {
  id: FilterId.MULTI_SENIORITY,
  name: 'Seniority',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.SENIORITY,
  instances: [],
  isVisible: true,
};

export const multiSeniorityHandler: FilterHandler<MultiFilter<ListFilter>> = {
  isActive(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.some((instance) =>
      seniorityHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      seniorityHandler.getEffectiveFilter(instance, seniorityDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
